import { api } from "@/services";

export async function addProductRequest(
  checkoutId: string,
  productId: string,
  ammount: number,
  store: string,
  wantDiscount?: boolean
) {
  try {
    const { data } = await api.post("Cart/AddProduct", null, {
      params: {
        CheckoutId: checkoutId,
        ProductId: productId,
        Qtd: ammount,
        store: store,
        wantDiscount: wantDiscount
      }
    });

    return { data };
  } catch (error) {
    console.error(error);
  }
}

// TODO: Bind the clientId and add to request
